import { IoInformationCircleOutline } from 'react-icons/io5';
import { Strings } from '@/constants/strings';

interface LegalInfoModalProps {
  visible: boolean;
  onClose: () => void;
}

export function LegalInfoModal({ visible, onClose }: LegalInfoModalProps) {
  if (!visible) return null;

  return (
    <div
      className="animate-modal-backdrop fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4 backdrop-blur-lg"
      role="dialog"
      aria-modal="true"
      aria-labelledby="legal-modal-title"
      onClick={onClose}
    >
      <div
        className="animate-modal-content relative flex max-h-[90vh] w-full max-w-md flex-col rounded-3xl bg-white/90 shadow-xl backdrop-blur-lg"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex shrink-0 items-center justify-between border-b border-border px-4 py-3">
          <div className="flex items-center gap-2">
            <IoInformationCircleOutline className="h-6 w-6 shrink-0 text-primary" aria-hidden />
            <h2 id="legal-modal-title" className="text-lg font-bold text-[#1A1A1A]">
              {Strings.legalModalTitle}
            </h2>
          </div>
          <button
            type="button"
            onClick={onClose}
            className="rounded p-1.5 text-[#5C5C5C] hover:bg-surface focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2"
            aria-label={Strings.close}
          >
            <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
              <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        <div className="min-h-0 flex-1 overflow-y-auto px-4 py-4">
          <section className="mb-6">
            <h3 className="mb-2.5 text-sm font-bold text-[#1A1A1A]">
              {Strings.legalModalDisclaimerHeading}
            </h3>
            <p className="text-sm leading-relaxed text-[#1A1A1A]">
              {Strings.legalModalDisclaimerText}
            </p>
          </section>

          <section className="mb-6">
            <h3 className="mb-2.5 text-sm font-bold text-[#1A1A1A]">
              {Strings.legalModalPrivacyHeading}
            </h3>
            <p className="text-sm leading-relaxed text-[#1A1A1A]">
              {Strings.legalModalPrivacyText}
            </p>
          </section>

          <section className="mb-6">
            <h3 className="mb-2.5 text-sm font-bold text-[#1A1A1A]">
              {Strings.legalModalContactHeading}
            </h3>
            <p className="text-sm leading-relaxed text-[#1A1A1A]">
              {Strings.legalModalContactText}{' '}
              <a
                href={`mailto:${Strings.legalModalContactEmail}`}
                className="font-medium text-primary underline hover:text-primary/80 focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-1"
              >
                {Strings.legalModalContactEmail}
              </a>
            </p>
          </section>

          <section>
            <h3 className="mb-2.5 text-sm font-bold text-[#1A1A1A]">
              {Strings.legalModalReferencesHeading}
            </h3>
            <p className="text-sm leading-relaxed text-[#1A1A1A]">
              {Strings.legalModalReferencesText}
            </p>
          </section>
        </div>

        <footer className="shrink-0 border-t border-border px-4 py-3 text-center text-xs text-[#5C5C5C]">
          {Strings.legalModalVersion}
        </footer>
      </div>
    </div>
  );
}
